import Login from './Login.vue'
import Licenses from './secure/components/Licenses.vue'
import NotFound from './secure/components/404.vue'

const routes = [
  {
    path: '/web',
    redirect: {
      name: 'home'
    }
  },
  {
    path: '/web/login',
    name: 'login',
    component: Login
  },
  {
    path: '/web/home',
    name: 'home',
    component: Licenses
  },
  {
    path: '*',
    name: 'notFound',
    component: NotFound
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js